import React, { useState, useEffect, forwardRef } from 'react';
import { tags } from '../../utils/api';
import { toast } from 'react-toastify';
import TagBadge from '../Documents/atoms/TagBadge';

const TagSelector = forwardRef(({ selectedTagIds, onChange, className = '', prefix = '' }, ref) => {
  const [availableTags, setAvailableTags] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchTags = async () => {
    try {
      const fetchedTags = await tags.getAll();
      setAvailableTags(fetchedTags);
    } catch (err) {
      toast.error('Failed to load tags');
    } finally {
      setIsLoading(false);
    }
  };

  // Initial fetch
  useEffect(() => {
    fetchTags();
  }, []);

  // Expose refresh method
  React.useImperativeHandle(ref, () => ({
    refresh: fetchTags
  }));

  const handleToggleTag = (tagId) => {
    const newTagIds = selectedTagIds?.includes(tagId)
      ? (selectedTagIds || []).filter(id => id !== tagId)
      : [...(selectedTagIds || []), tagId];
    onChange(newTagIds);
  };

  if (isLoading) {
    return (
      <div className={`border border-gray-300 rounded-md p-2 ${className}`}>
        <div className="flex items-center justify-center h-16">
          <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-indigo-600"></div>
        </div>
      </div>
    );
  }

  if (availableTags.length === 0) {
    return (
      <div className={`border border-gray-300 rounded-md p-2 ${className}`}>
        <div className="flex items-center justify-center h-16">
          <span className="text-sm text-gray-500">No tags available</span>
        </div>
      </div>
    );
  }

  return (
    <div className={`border border-gray-300 rounded-md p-2 ${className}`}>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
        {availableTags.map(tag => (
          <label key={tag.id} htmlFor={`${prefix}tag-${tag.id}`} className="inline-flex items-center group">
            <input
              type="checkbox"
              id={`${prefix}tag-${tag.id}`}
              name={`${prefix}tag-${tag.id}`}
              checked={selectedTagIds.includes(tag.id)}
              onChange={() => handleToggleTag(tag.id)}
              className="form-checkbox h-4 w-4 text-indigo-600 rounded mr-2"
            />
            <div className="flex-1 flex items-center">
              <TagBadge
                name={`${tag.name} (${tag.coin_count || 0})`}
                color={tag.color}
                interactive={false}
                className="group-hover:opacity-90"
              />
            </div>
          </label>
        ))}
      </div>
    </div>
  );
});

export default TagSelector;
